const widgetName = 'socialNetworkWidget';
let initialized = false;

function initialize() {
  initialized = true;
}


// FACEBOOK -----------

function facebookfeed() {

  const facebookfeedContainer = `
  <div class="socialFeedWrapper">
    <div class="socialFeedHeading facebookfeedHeading">
      <a href="https://www.facebook.com/TEXASOutdoorMusical/" target="_blank">FACEBOOK</a>
    </div>
    <div id="facebookfeedContainer" class="socialFeedContainer">
      <div class="fb-page" data-href="https://www.facebook.com/TEXASOutdoorMusical/" data-width="360" data-adapt-container-width="true" data-height="390" data-small-header="true" data-hide-cover="false" data-show-facepile="false" data-show-posts="true">
        <div class="fb-xfbml-parse-ignore">
          <blockquote cite="https://www.facebook.com/TEXASOutdoorMusical/"><a href="https://www.facebook.com/TEXASOutdoorMusical/">Loading...</a></blockquote>
        </div>
      </div>
    </div>
  </div>
  `;
    
  if (!initialized) {
    initialize();
  }

  $(`#${widgetName}`).append(facebookfeedContainer);


}


// INSTAGRAM -----------

function instafeed() {

  const instafeedContainer = `
  <div class="socialFeedWrapper">
    <div class="socialFeedHeading instafeedHeading">
      <a href="https://www.instagram.com/texasoutdoormusical/" target="_blank">INSTAGRAM</a>
    </div>
    <div id="instafeedContainer" class="socialFeedContainer"></div>
  </div>
  `;
  
  if (!initialized) {
    initialize();
  }

  $(`#${widgetName}`).append(instafeedContainer);

  const feed = new Instafeed({
    target: 'instafeedContainer'
  });
  feed.run();

}


// TWITTER -----------

function twitterfeed() {

  const widgetOpts = socialNetworkWidgetOpts;

  const twitterfeedContainer = `
  <div class="socialFeedWrapper">
    <div class="socialFeedHeading twitterfeedHeading">
      <a href="https://twitter.com/TEXAStheMUSICAL" target="_blank">TWITTER</a>
    </div>
    <div id="twitterfeedContainer" class="socialFeedContainer"></div>
  </div>
  `;

  if (!initialized) {
    initialize();
  }

  $(`#${widgetName}`).append(twitterfeedContainer);

  var twitterPanelLoaded = function () {};

  var getTweetDate = function (dateData) {
    var parsedTweetDate = new Date(
      dateData.replace(/^\w+ (\w+) (\d+) ([\d:]+) \+0000 (\d+)$/,
        "$1 $2 $4 $3 UTC"));
    var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    var dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return "<span class='tweetDate'>" + dayNames[parsedTweetDate.getDay()] + " " + monthNames[parsedTweetDate.getMonth()] + " " + parsedTweetDate.getDate() + ", " + parsedTweetDate.getFullYear() + "</span>";
  }

  var tweetNumber = 10;

  var getTwitterFeedDataSuccess = function (data) {

    if (data.d != undefined) {
  
      if (data.d != null && data.d != '') {
  
        var twitterLatestTweets = JSON.parse(data.d);
  
        if (twitterLatestTweets.length > 0) {
  
          for (var i = tweetNumber - 1; i >= 0; i--) {
  
            if (twitterLatestTweets[i] != null && twitterLatestTweets[i] != undefined && twitterLatestTweets[i] != '') {
  
              var latestTweet = twitterLatestTweets[i];
              var linkedTweet = linkify_entities(latestTweet);
  
              var tweetDate = getTweetDate(latestTweet.created_at);
  
              var linkedTweetElement = $('<div class="twitterFeedItem"><div class="twtr-tweet-text">' + tweetDate + linkedTweet + '</div></div>');
  
              $('#twitterfeedContainer').prepend(linkedTweetElement);
            }
  
          }
  
          var userName = latestTweet.user.name;
          var screenName = latestTweet.user.screen_name;
          var followerCount = latestTweet.user.followers_count;
          var userDescription = latestTweet.user.description;
          var profileBannerURL = latestTweet.user.profile_banner_url;
          var profilePicURL = latestTweet.user.profile_image_url_https.replace("_normal", '');
  
          if (followerCount >= 100) {
            var userBanner = '<div class="twitter-user-banner" style="background-image: url(' + profileBannerURL + ')"><div class="twitter-user-followers">Followers<span>' + followerCount + '</span></div></div>';
          } else {
            var userBanner = '<div class="twitter-user-banner" style="background-image: url(' + profileBannerURL + ')"></div>';
          }
  
          var screenNameLink = '<div class="twitter-user-screenName"><span>' + userName + '</span><a href="https://twitter.com/' + screenName + '" target="_blank">@' + screenName + '</a></div>';
          var userProfilePic = '<a href="https://twitter.com/' + screenName + '" class="twitter-user-profilePic" style="background-image: url(' + profilePicURL + ')" target="_blank"></a>';
  
          $('#twitterfeedContainer').prepend('<div class="twtr-tweet-user" >' + userBanner + '<div class="twitter-user-info">' + userProfilePic + screenNameLink + '<p class="twitter-user-description">' + userDescription + '</p>' + '</div></div>');
  
          $('#twitterfeedContainer').append('<a href="https://twitter.com/' + screenName + '" class="more-tweets-btn" target="_blank">More Tweets</a>');
  
        }
      }
    }
  
    twitterPanelLoaded();
  
  };

  var getTwitterFeedDataError = function (data) {
    console.log('Twitter Feed failed to retrieve data', '\n' + 'Status: ' + data.status + ' ' + data.statusText, '\n' + data.responseText);  
  };

  $.ajax({
    type: "POST",
    url: widgetOpts.scriptPath,
    data: "{'tweetCount': " + tweetNumber + "}",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    success: getTwitterFeedDataSuccess,
    error: getTwitterFeedDataError
  });

  twitterPanelLoaded = function () {
    $('.twitterFeedItem').each(function () {
      var el = $(this)
      $('.twitterWidgetImageLink', this).prependTo(el);
    })
  }

}


export {facebookfeed, instafeed, twitterfeed};